import { Collection } from 'modules/core/lib/mobx-rest'

import RestDay from 'modules/shift_management/store/api/models/RestDay'

class RestDays extends Collection<RestDay> {
  get cacheKey(): string {
    return 'restDays'
  }
  model() {
    return RestDay
  }
}

const singleton: RestDays = new RestDays()

export default singleton
